import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxPlanoInsDocs from "./_components/BoxPlanoInsDocs";

const PlanoInsDocs = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxPlanoInsDocs />
    </ContentWrapper>
  </>
);

export default PlanoInsDocs;
